import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Page } from 'src/app/models/page.model';
import { CommonService } from 'src/app/services/common.service';
import { AlertController, IonContent } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { DatePipe, Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';
import { AuthService } from 'src/app/services/auth.service';
import { TranslationService } from 'src/app/services/translation.service';
import { MomentDateTimeAdapter } from '@danielmoncada/angular-datetime-picker-moment-adapter';

declare function openChat(username: string, userEmail: string, teamleaderGUID: string, documentGUID: string):any;

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY HH:mm',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
@Component({
  selector: 'app-documentlibrarydetails',
  templateUrl: './documentlibrarydetails.page.html',
  styleUrls: ['./documentlibrarydetails.page.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
  ],
})
export class DocumentlibrarydetailPage implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild('uploader', { static: false }) uploader: any;
  @ViewChild('table') table: DatatableComponent;
  documentForm: FormGroup;
  duplicateForm: FormGroup;
  uplaodForm: FormGroup;
  columnsWidth: any = [];
  page = new Page();
  rows: any = [];
  isUpload: boolean = false;
  docxName:any;
  fileUpload:any;
  documentId: string = '';
  versionId: string = '';
  document: any;
  showView: boolean = false;
  showAdjustDuplicateTiles: boolean = false;
  showUpload: boolean = false;
  showPage: boolean = false;
  sectionName: string;
  submitted: boolean = false;
  submittedDuplicateForm: boolean = false;
  submittedUploadForm: boolean = false;
  showDeleteButton: boolean = false;
  hideDownload: boolean = false;
  hideVersionHistory: boolean = false;
  duplicateData: any = {};

  adjustColumnWidth() {
    if (this.table && window.innerWidth > 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.DateCreated = (20 / 100) * tableWidth;
      this.columnsWidth.CreatedBy = (25 / 100) * tableWidth;
      this.columnsWidth.Version = (20 / 100) * tableWidth;
      this.columnsWidth.Remarks = (40 / 100) * tableWidth;
    }
    if (this.table && window.innerWidth < 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.DateCreated = (35 / 100) * tableWidth;
      this.columnsWidth.CreatedBy = (20 / 100) * tableWidth;
      this.columnsWidth.Version = (20 / 100) * tableWidth;
      this.columnsWidth.Remarks = null;
    }
  }

  constructor( private datePipe: DatePipe, private location: Location, public _translationService:TranslationService, private _authService: AuthService, private _apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, public _commonService: CommonService, private alertController: AlertController,) {
    this.page.pageNumber = 0;
    this.page.size = 20;
    this.page.orderBy = '';
    this.page.orderDir = '';
  }

  ngOnInit() {

    this.documentForm = this.formBuilder.group({
      Name: ['', Validators.required],
      DateCreated: [''],
      Remarks: [''],
    });
    this.duplicateForm = this.formBuilder.group({
      Name: ['', Validators.required],
    });
    this.uplaodForm = this.formBuilder.group({
      DocumentFileNaame: ['', Validators.required],
      Remarks: ['', Validators.required],
    });
  }

 ionViewWillEnter(){
  sessionStorage.removeItem('dashboardDocumentId')
  sessionStorage.removeItem('documentVersionId')
  sessionStorage.removeItem('documentVersionArchieve')
  this.hideDownload = false;
  this.documentId = this.route.snapshot.paramMap.get('documentId');
  this.sectionName = this.route.snapshot.paramMap.get('sectionName');
  if(this.sectionName == 'standarddocument'){
    let k = this.route.snapshot.paramMap.get('domainId');
    if(k==null){
      this.location.replaceState('documentlibrary/standarddocument/'+ this.documentId + '/' + localStorage.domainId);
    }
  }
  if(localStorage.checkBasisDocument) this._commonService.IsHideHelpChatTile = localStorage.checkBasisDocument;
  if(this._commonService.redirectURL && localStorage.domainId != this._commonService.redirectDomainId){
    this.changeDomain()
  }else{
    if (this.documentId == '0') {
      this.documentId = null;
      console.log(this.documentId);
      this.showView = true;
      this.showUpload = true;
      this.hideVersionHistory = true;
    }
    if (this.documentId) {
      if(this.sectionName == "standarddocument") {
        this.showDeleteButton = false;
        this.getStandardDocumentDetails();
      } else {
        this.getDocumentDetail();
      }
    }
  }

  this.duplicateData = {
    DocumentName: ""
  }
  }

  ionViewDidEnter() {
    this.adjustColumnWidth();
  }

  ionViewDidLeave() {
    this.showView = false;
    this.showAdjustDuplicateTiles = true;
    this.showUpload = true;
    this.hideDownload = false;
  }

  goBack() {
    this.router.navigate(['documentlibrary'], { replaceUrl: true });
  }

  setPage(event) {
    this.page.pageNumber = event.offset + 1;
  }


  async getDocumentDetail() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getDocumentLibraryDetails(this.documentId);
      this.document = res.body;
      if( this.document.Module == "Module_Quickscan") {
        this.showAdjustDuplicateTiles = false;
        this.showUpload = false;
        this.showDeleteButton = true;
        this.hideVersionHistory = true;
      } else {
        this.document.DownloadDocumentId = this.document.DocumentId;
        this.document.DownloadDocumentVersionId = this.document.DocumentVersionId;
        this.showAdjustDuplicateTiles = true;
        this.showUpload = true;
        this.showDeleteButton = true;
        this.getVersion();
        if(this.document.Locked == "1") {
          this.isUpload = true;
        } else {
          this.isUpload = false;
        }
      }
      if(this.document.Module == "Module_CustomDocument") {
        this.hideDownload = false;
        this.showAdjustDuplicateTiles = false;
      } else if(!this.document.IsComplete) {
        this.hideDownload = true;
      }
      this.documentForm.patchValue({
        Name: this.document.DocumentName,
        DateCreated: this.datePipe.transform(new Date(this.document.DateCreated), "dd-MM-yyyy HH:mm"),
        Remarks: this.document.Remarks,
      });
      this.documentForm.updateValueAndValidity();
      this.showView = true;
      setTimeout(() => {
        this.adjustColumnWidth();
      }, 200);
      this._commonService.redirectURL = null;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  async getStandardDocumentDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getStandardDocumentDetail(this.documentId);
      this.document = res.body;
      this.showAdjustDuplicateTiles = false;
      this.showUpload = false;
      this.document.DocumentName =  this.document.Name;

   this.documentForm.patchValue({
        Name: this.document.Name,
        DateCreated: this.datePipe.transform(this.document.DateCreated, 'dd-MM-yyyy hh:mm'),
        Remarks: this.document.Remarks,
      });
      this.documentForm.updateValueAndValidity();
      this.showView = true;
      this._commonService.dismiss();
      this._commonService.redirectURL = null

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  get f() { return this.documentForm.controls; }
  get fd() { return this.duplicateForm.controls; }
  get fu() { return this.uplaodForm.controls; }

  async getVersion(){
    try{
      this._commonService.presentLoading();
      let res = await this._apiService.getDocumentVersions(this.documentId, "", '', '');
      this.rows = res.body;
      this.showPage = true;

      this._commonService.log(this.rows, this._commonService.LOG);
      this._commonService.dismiss();

    }catch(error){
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async askDocQuestionChat(){
    try {
    this._commonService.presentLoading();
    let res = await this._apiService.putAskDocQuestionChat(this.documentId, {});
      if (res) {
       this.startDocQuestionChat();
      }
      this._commonService.log(this.documentId, this._commonService.LOG);
      this._commonService.dismiss();
    }
    catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  startDocQuestionChat(){
    var email = localStorage.userName ? localStorage.userName : "Unknown";
    var firstName = localStorage.firstName ? localStorage.firstName : "Unknown";
    var teamleaderGUID = localStorage.TeamLeaderGuid ?  localStorage.TeamLeaderGuid : 'Unknown';
    openChat(firstName, email, teamleaderGUID, this.documentId);
  }


  async download() {
    if(this.sectionName == "standarddocument") {
      this.downloadStandardDocument()
    } else if(this.sectionName == "documents") {
    if(this.document.Module == "Module_Quickscan") {
      this.downloadQuickscan();
    } else if(this.document.Module == "Module_CustomDocument") {
      this.downloadOwnDocument();
    } else {
      this.downloadDocument();
    }
    }

  }

  async downloadQuickscan() {
    try {
      this._commonService.presentLoading();

      let res = await this._apiService.getDownloadDocumentLibrary(this.document.QuickScanFormId, "", "Module_Quickscan", "");
      this._commonService.dismiss();
      let blob = new Blob([res.body])
      const url = window.URL.createObjectURL(blob);
      let name = 'quickscanreport_' + this.datePipe.transform(new Date(), "yyyyMMddHHmmss")
      const fileName = name + '.pdf';

      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = fileName;
      downloadLink.click();
      blob = new Blob([res.body], { type: 'application/pdf' });
      let newWindow = window.open('', "_blank");
      newWindow.location.href = URL.createObjectURL(blob);
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  async downloadDocument() {
    try {
      this._commonService.presentLoading();
      let isLocked;
      if(this.isUpload == true) {
        isLocked = "1";
      } else {
        isLocked = "0";
      }
      let res = await this._apiService.getDownloadDocumentLibrary(this.document.DownloadDocumentId, this.document.DownloadDocumentVersionId, "Documents", isLocked);
      var blob = new Blob([res.body], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
      const fileName = res.headers.get('X-Blob-FileName');

      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);;
      downloadLink.download = fileName;
      downloadLink.click();
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  async downloadOwnDocument() {
    try {
      this._commonService.presentLoading();

      let res = await this._apiService.getDownloadDocumentLibrary(this.document.DownloadDocumentId, this.document.DownloadDocumentVersionId, "Module_CustomDocument", "");
      this._commonService.dismiss();
      if(res["body"].type == 'application/pdf') {
        let blob = new Blob([res.body])
        const url = window.URL.createObjectURL(blob);
        // let name = 'owndocument_' + this.datePipe.transform(new Date(), "yyyyMMddHHmmss")
        const fileName = this.documentForm.value.Name + '.pdf';

        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
        blob = new Blob([res.body], { type: 'application/pdf' });
        let newWindow = window.open('', "_blank");
        newWindow.location.href = URL.createObjectURL(blob);
      } else {
        var blob = new Blob([res.body], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
      const fileName = res.headers.get('X-Blob-FileName');

      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);;
      downloadLink.download = fileName;
      downloadLink.click();
      }

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async downloadStandardDocument() {
    try {
      this._commonService.presentLoading();

      let res = await this._apiService.getDownloadStandardDocument(this.document.StandardDocumentId);
      var blob = new Blob([res.body], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
      const fileName = res.headers.get('X-Blob-FileName');

      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);;
      downloadLink.download = fileName;
      downloadLink.click();
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async onSubmit() {
    this.submitted = true;
    if (this.documentForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
    this._commonService.presentLoading();
    try {
      let data = {
        'DocumentName': this.documentForm.value.Name,
        'Remarks': this.documentForm.value.Remarks
      }
      let res = await this._apiService.putDocumentDetail(this.documentId, data)
      this._commonService.log(this.documentId, this._commonService.LOG);
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this.submitted = false;
    }
    catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async adjustment() {
    try {
      let res = await this._apiService.putAdjustment(this.documentId, {});
      if (res) {
        sessionStorage.dashboardDocumentId = res.DocumentId ? res.DocumentId : null;
        sessionStorage.documentVersionId = res.DocumentVersionId ? res.DocumentVersionId : null;
        sessionStorage.documentVersionArchieve = res.Archive ? res.Archive : null;
        if(this.document.IsComplete){
          sessionStorage.setItem('IsCompleted', "true");
        } else {
          sessionStorage.removeItem('IsCompleted');
        }
        this.router.navigate(['/documentgenerator/wizard/' + res.DocumentTemplateId + '/' + res.DocumentTemplateVersionId]);

      }
      this._commonService.log(this.documentId, this._commonService.LOG);
      this._commonService.dismiss();
    }
    catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }

  }


  async confirmUpload() {
    this.submittedUploadForm = true;
    if (this.uplaodForm.invalid) {
      return;
    }
    if (!this.documentId || this.document.Module == "Module_CustomDocument") {
      this._commonService.presentLoading();
      try {
        let formData = new FormData();
        formData.append('file', this.fileUpload);
        formData.append('DocumentName', this.docxName ? this.docxName : this.uplaodForm.value.DocumentFileNaame);
        formData.append('Remarks', this.uplaodForm.value.Remarks);
        let id = this.document && this.document.DocumentId ? this.document.DocumentId : '0';
        if(this.document && this.document.Module == "Module_CustomDocument") {
          formData.append('DocumentId', this.document.DocumentId);
        }
        let res = await this._apiService.patchUploadOrDuplicateData(formData, id, 'false', "Module_CustomDocument");
        if (res.body && this.documentId) {
          this.document.DownloadDocumentId = res.body.DocumentId;
          this.document.DownloadDocumentVersionId = res.body.DocumentVersionId;
          this.getVersion();
          this.goTop();
          this.getDocumentDetail();
          // this.router.navigate(['/documentlibrary/' + 'documents/' + res.body.DocumentId + "/" + localStorage.domainId]);
        }else{
          if(res.body){
            this.router.navigate(['/documentlibrary/' + 'documents/' + res.body.DocumentId + "/" + localStorage.domainId]);
          }
        }
        this._commonService.dismiss();
        this._commonService.showToast(this._commonService.getLocalTranslation('label-documentUploaded'));
        this.submittedUploadForm = false;
        this.uplaodForm.patchValue({
          Remarks: "",
          DocumentFileNaame: ""
        });
        this.uplaodForm.updateValueAndValidity();
      }
      catch (error) {
        this.uplaodForm.enable();
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    } else {
      const alert = await this.alertController.create({
        header: this._commonService.getLocalTranslation('label-pleaseConfirm'),
        message: this._commonService.getLocalTranslation('label-afterManualUpload'),
        buttons: [
          {
            text: this._commonService.getLocalTranslation('label-ok'),
            handler: async () => {
              this.isUpload = true;
              this._commonService.presentLoading();
              try {
                let formData = new FormData();
                formData.append('file', this.fileUpload);
                formData.append('DocumentName', this.docxName ? this.docxName : this.uplaodForm.value.DocumentFileNaame);
                formData.append('Remarks', this.uplaodForm.value.Remarks);
                let id = this.document && this.document.DocumentId ? this.document.DocumentId : '0';
                let res = await this._apiService.patchUploadOrDuplicateData(formData, id, 'false', "");
                this._commonService.dismiss();
                if (res.body) {
                  this.document.DownloadDocumentId = res.body.DocumentId;
                  this.document.DownloadDocumentVersionId = res.body.DocumentVersionId;
                  this.getVersion();
                  this.goTop();
                  if (this.sectionName == "standarddocument") {
                    this.showDeleteButton = false;
                    this.getStandardDocumentDetails();
                  } else {
                    this.getDocumentDetail();
                  }
                }
                this._commonService.dismiss();
                this._commonService.showToast(this._commonService.getLocalTranslation('label-documentUploaded'));
                this.submittedUploadForm = false;
                this.uplaodForm.patchValue({
                  Remarks: "",
                  DocumentFileNaame: ""
                });
                this.uplaodForm.updateValueAndValidity();
              }
              catch (error) {
                if (this.document.Locked != "1") {
                  this.isUpload = false;
                }
                this.uplaodForm.enable();
                this._commonService.dismiss();
                this._commonService.log(error, this._commonService.ERROR);
              }
            }
          },
          {
            text: this._commonService.getLocalTranslation('label-cancel'),
            role: 'cancel',
            handler: () => {
            }
          }


        ]
      });
      await alert.present();
    }
  }

  async goTop() {
    if (this.content) {
      this.content.getScrollElement().then(el => {
        if (el) {
          this.content.scrollToPoint(0, 0, 0);
        }
      });
    }
  }

  changeDomain() {
    this._commonService.presentLoading();
    let params = {
      LocaleCode: ((localStorage.locale && !Number.isNaN(Number(localStorage.locale))) ? localStorage.locale : 1043),
      DomainId: this._commonService.redirectDomainId
    }
    this._authService.doDomainLogin(params, 'Login/Domain', localStorage.authenticationKey).subscribe(
      async (res) => {

        let authenticationKey = localStorage.authenticationKey;
        let menuItems = localStorage.menuItems;
        let domains = localStorage.domains;
        this._commonService.clearData();
        localStorage.authenticationKey = authenticationKey;
        localStorage.menuItems = menuItems;
        localStorage.domains = domains;

        let currentTime = new Date();
        localStorage.sessionStartTime = currentTime.getHours();

        localStorage.setItem('userId', res.UserId);
        localStorage.setItem('userName', res.UserName);
        localStorage.setItem('firstName', res.FirstName);
        localStorage.setItem('domainLocales', JSON.stringify(res.Locales));
        localStorage.setItem('menuItems', JSON.stringify(res.MenuItems));
        localStorage.setItem('domainName', res.DomainName);
        localStorage.setItem('authenticationKey', res.AuthenticationKey);
        localStorage.setItem('domainId', res.DomainId);
        localStorage.setItem('roleCode', res.RoleCode);
        localStorage.setItem('linkedToMultipleDomains', res.LinkedToMultipleDomains);
        localStorage.setItem('MaxAllowedCompanyPerDomain', res.MaxAllowedCompanyPerDomain);
        localStorage.setItem('helpImageChangeInterval', res.HelpImageChangeInterval);
        localStorage.setItem('notificationsUnreadCount', res.NotificationsUnreadCount ? res.NotificationsUnreadCount : 0);
        localStorage.setItem('Datecreated', res.Datecreated ? res.Datecreated : '');
        localStorage.setItem('FirstLogin', res.FirstLogin ? res.FirstLogin : 'false');
        localStorage.setItem('DomainSubscriptionContactNumber', res.DomainSubscriptionContactNumber ? res.DomainSubscriptionContactNumber : '');
        localStorage.setItem('TeamLeaderGuid',res.TeamLeaderGuid);

        this._commonService.phoneNumber = res.DomainSubscriptionContactNumber ? res.DomainSubscriptionContactNumber : ''
        if (res.Logo) {
          this._commonService.logo = 'data:image/png;base64,' + res.Logo;
          localStorage.setItem('Logo', 'data:image/png;base64,' + res.Logo);
        } else {
          this._commonService.logo = null;
          localStorage.removeItem('Logo');
        }

        if (res.CustomerLogo) {
          this._commonService.customerLogo = 'data:image/png;base64,' + res.CustomerLogo;
          localStorage.setItem('customerLogo', 'data:image/png;base64,' + res.CustomerLogo);
        } else {
          this._commonService.customerLogo = null;
          localStorage.removeItem('customerLogo');
        }

        this._commonService.linkedToMultipleDomains = res.LinkedToMultipleDomains
        this._commonService.notificationsUnreadCount = res.NotificationsUnreadCount ? res.NotificationsUnreadCount : 0

        this._commonService.linkedToMultipleDomains = res.LinkedToMultipleDomains
        if (res.RoleCode == 'UserRole_CustomerAdmin') {
          this._commonService.isCustomerAdmin = true
        }
        if (res.RoleCode == 'UserRole_CustomerUser') {
          this._commonService.isCustomerUser = true
        }
        if (res.RoleCode == 'UserRole_Support') {
          this._commonService.isSupportUser = true
        }
        if (res.RoleCode == 'UserRole_Legal') {
          this._commonService.isJuristUser = true
        }


        localStorage.setItem('userRoles', res.UserRoles ? JSON.stringify(res.UserRoles) : null);


        this._commonService.domainLocales = res.Locales;


        if (res.Locales.length == 1) {
          this._commonService.locale = res.Locales[0].LocaleId;
          localStorage.locale = res.Locales[0].LocaleId;
        }
        localStorage.locale = res.DefaultLocale
        this._commonService.locale = res.DefaultLocale

        this._commonService.menuItems = res.MenuItems;
        this._commonService.domainName = res.DomainName;

        this._commonService.domain = {
          DomainId: res.DomainId,
          Name: res.DomainName
        }

        if(localStorage.currentImage){
          localStorage.removeItem('currentImage')
        }

        if(localStorage.helpDetail){
          localStorage.removeItem('helpDetail')
        }

        this._commonService.dismiss();

        this._translationService.getTranslation(localStorage.locale);
        if (this._commonService.redirectURL) {
          let url = this._commonService.redirectURL.split('/');
          this._commonService.redirectURL = null;
          this.router.navigate(['documentlibrary/' + url[2] + '/' + url[3] + '/' + url[4]]);
        }

        else if (res.RoleCode == 'UserRole_Administrator') {
          this.router.navigate(['/maintenance']);
          this._commonService.isAdmin = true
        }
        else this.router.navigate(['/dashboard']);

        this._commonService.isLoggedIn = true;

        this._commonService.getNotificationCount();



        localStorage.domains = res.LinkedDomains ? JSON.stringify(res.LinkedDomains) : null;
        this._commonService.getFAQS()
        try {
          let moduleList = await this._apiService.getModules('', '', '', 1, 0);
          localStorage.moduleList = JSON.stringify(moduleList.body);

        } catch (error) {
          localStorage.sessionStartTime = "";
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }

        try {
          let settingList = await this._apiService.getSettings('', '', '', 1, 0);
          settingList.body.forEach((value, index) => {
            if (value.SettingName == "Force2FactorAuthentication") {
              localStorage.Force2FactorAuthentication = value.SettingValue;
            }
            if (value.SettingName == "TeamleaderTags") {
              localStorage.TeamleaderTags = value.SettingValue;
            }

          })
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
        if (this.sectionName == "standarddocument") {
          this.getStandardDocumentDetails();
        } else {
          this.getDocumentDetail();
        }

      },
      (err) => {
        this._commonService.log(err, this._commonService.ERROR);
        this._commonService.dismiss();
      }
    );
  }

  upload() {
    this.uploader.nativeElement.click();
  }

  async onSelectFile(files: any) {
    let items: any = [];
    try {
      if (files.length > 0 && files.length < 50) {
        let fileName = files[0].name;
        this.fileUpload = files[0];
        let ext = null;
        this.docxName = fileName;

        this.uplaodForm.patchValue({
          DocumentFileNaame: fileName
        });
        this._commonService.dismiss();
      } else if (files.length > 50) {
        this._commonService.dismiss();
        this._commonService.presentAlert("", this._commonService.getLocalTranslation('label-fileNumberExceeded'));
      }
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
    this.uploader.nativeElement.value = null;
  }

  async onSort(event) {
    const sort = event.sorts[0];
    this.page.orderBy = sort.prop.toLowerCase();
    this.page.orderDir = sort.dir;
  }

  async duplicate() {
    this.submittedDuplicateForm = true;
    if (this.duplicateForm.invalid) {
      return;
    }
    this._commonService.presentLoading();
    try {
      let data= {
        'DocumentName': this.duplicateForm.value.Name
      }
      let res= await this._apiService.patchUploadOrDuplicateData(data, this.documentId, 'true', "");
      this._commonService.log(this.documentId, this._commonService.LOG);
      this.documentId = res.body.DocumentId;
      console.log(this.documentId);
      if(this.sectionName == "standarddocument") {
        this.showDeleteButton = false;
        this.getStandardDocumentDetails();
      } else {
        this.getDocumentDetail();
      }
      this.goTop();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-documentDuplicated'));
      this._commonService.dismiss();
      this.submittedDuplicateForm = false;
      this.duplicateForm.patchValue({
        Name: ""
      });
    }
    catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  deleteDocument(){
    this._commonService.presentDocumentAlertConfirm()
    .then(async (res) => {
      try {
        this._commonService.presentLoading();
        await this._apiService.deleteDocuments(this.documentId);
        this._commonService.dismiss();
        this.router.navigate(['documentlibrary'], { replaceUrl: true });
        this._commonService.log(res, this._commonService.LOG);
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    })
    .catch((err) => {
      this._commonService.log(err, this._commonService.LOG);
    })
  }

}
